define(['backbone', 'models/TimeZone'], function(Backbone, TimeZoneModel) {
  return Backbone.Collection.extend({
    model: TimeZoneModel
  });
});
